import React from 'react';
import { connect } from 'react-redux';
import styles from "../login_page.module.scss"
import { Button, Spinner } from "react-bootstrap";
import clsx from 'clsx';

const SubmitButton = ({requestPendingFromRedux, requestPending, text, pendingText, className, disabled = false}) => {
  // Use passed prop if available, otherwise fallback to Redux
  const isPending = requestPending !== undefined ? requestPending : requestPendingFromRedux;

  return (
    <Button type="submit" size="lg"  className={clsx(styles.submitBtn, className)} disabled={isPending || disabled}>
      {isPending && (
        <Spinner
          as="span"
          animation="grow"
          size="sm"
          role="status"
          aria-hidden="true"
          className={styles.spinner}
        />
      )}
      {isPending ? pendingText : text}
    </Button>
  );
};

const mapStateToProps = (state) => ({
  requestPendingFromRedux: state.authentication.requestPending,
});

export default connect(mapStateToProps)(SubmitButton);